import React, { useState } from "react";
import { X, Send, Sparkles } from "lucide-react";

const prompts = [
  { q: "What does Duaura build?", href: "#services" },
  { q: "How long does deployment take?", href: "#process" },
  { q: "What industries do you work with?", href: "#services" },
  { q: "How do I book a call?", href: "#book" },
];

export default function Assistant() {
  const [open, setOpen] = useState(false);

  return (
    <div
      data-testid="duaura-assistant"
      className="fixed left-4 sm:left-6 bottom-4 sm:bottom-6 z-40 flex flex-col items-start"
    >
      {open && (
        <div
          data-testid="assistant-panel"
          className="mb-3 w-[320px] sm:w-[360px] rounded-2xl bg-white border border-[var(--line)] shadow-[0_30px_60px_-20px_rgba(22,34,61,0.25)] overflow-hidden reveal"
        >
          {/* Header */}
          <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--line-soft)] bg-[var(--porcelain-mist)]">
            <div className="flex items-center gap-2.5">
              <span className="relative w-9 h-9 rounded-full overflow-hidden flex items-center justify-center bg-[var(--night)] ring-1 ring-[var(--camel)]/40">
                <img
                  src="/duaura-logo.png"
                  alt="Duaura"
                  className="w-full h-full object-contain p-1"
                />
              </span>
              <div>
                <div className="font-serif text-[15px] text-[var(--ink)] leading-none">
                  Duaura Assistant
                </div>
                <div className="font-mono text-[9.5px] tracking-[0.2em] uppercase text-[var(--ink-faint)] mt-1">
                  Relationship twin · Online
                </div>
              </div>
            </div>
            <button
              data-testid="assistant-close"
              onClick={() => setOpen(false)}
              className="w-7 h-7 rounded-full hover:bg-[var(--line-soft)] flex items-center justify-center text-[var(--ink-muted)]"
              aria-label="Close assistant"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {/* Greeting */}
          <div className="px-5 pt-5 pb-3">
            <div className="inline-flex items-center gap-1.5 mb-3">
              <Sparkles className="w-3.5 h-3.5 text-[var(--blue)]" />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--ink-faint)]">
                Ask me anything
              </span>
            </div>
            <p className="text-[13.5px] leading-[1.55] text-[var(--ink-soft)]">
              Hi — I know Duaura inside and out. Ask me what we build, how we
              partner with your team, or how to start a conversation about your
              AI journey.
            </p>
          </div>

          {/* Prompts */}
          <div className="px-5 pb-4">
            <div className="grid gap-2">
              {prompts.map((p, i) => (
                <a
                  key={i}
                  data-testid={`assistant-prompt-${i}`}
                  href={p.href}
                  onClick={() => setOpen(false)}
                  className="group text-left flex items-start gap-2.5 rounded-xl border border-[var(--line)] bg-white hover:bg-[var(--blue-tint)] hover:border-[var(--blue)]/30 px-3.5 py-2.5 transition-all"
                >
                  <span className="mt-1 w-1 h-1 rounded-full bg-[var(--blue)] shrink-0" />
                  <span className="text-[13px] text-[var(--ink)] leading-[1.4] group-hover:text-[var(--blue)] transition-colors">
                    {p.q}
                  </span>
                </a>
              ))}
            </div>
          </div>

          {/* Input row */}
          <form
            data-testid="assistant-input-form"
            onSubmit={(e) => {
              e.preventDefault();
              window.location.href = "#book";
              setOpen(false);
            }}
            className="border-t border-[var(--line-soft)] px-4 py-3 bg-[var(--porcelain-mist)] flex items-center gap-2"
          >
            <input
              data-testid="assistant-input"
              type="text"
              placeholder="Type your question…"
              className="flex-1 bg-transparent text-[13px] text-[var(--ink)] placeholder:text-[var(--ink-faint)] focus:outline-none"
            />
            <button
              type="submit"
              className="w-8 h-8 rounded-full btn-cobalt flex items-center justify-center"
              aria-label="Send"
            >
              <Send className="w-3.5 h-3.5" />
            </button>
          </form>
        </div>
      )}

      {/* Trigger pill */}
      <button
        data-testid="assistant-toggle"
        onClick={() => setOpen((v) => !v)}
        className="glass rounded-full pl-2 pr-4 py-2 flex items-center gap-2.5 hover:shadow-[0_20px_40px_-16px_rgba(69,102,199,0.4)] transition-all group"
      >
        <span className="relative w-9 h-9 rounded-full overflow-hidden flex items-center justify-center bg-[var(--night)] ring-1 ring-[var(--camel)]/40">
          <img
            src="/duaura-logo.png"
            alt="Duaura"
            className="w-full h-full object-contain p-1"
          />
        </span>
        <span className="flex flex-col text-left">
          <span className="font-serif text-[13px] leading-none text-[var(--ink)]">
            Duaura Assistant
          </span>
          <span className="font-mono text-[9px] tracking-[0.2em] uppercase text-[var(--ink-faint)] mt-1">
            Ask me anything
          </span>
        </span>
      </button>
    </div>
  );
}
